import { supabase } from "@/integrations/supabase/client";

/**
 * Set profile.email_verified = true for a user (e.g. after they accept a cleaner invite
 * so they are not required to go through the verify-email flow).
 * Tries sync_email_verified RPC first; falls back to direct update if RPC is unavailable.
 */
export async function setEmailVerifiedForUser(userId: string): Promise<void> {
  const { error: rpcError } = await supabase.rpc("sync_email_verified", { user_id: userId });
  if (!rpcError) return;
  const { error: updateError } = await supabase
    .from("profiles")
    .update({ email_verified: true })
    .eq("id", userId);
  if (updateError) {
    console.warn("[emailVerification] Could not set email_verified:", updateError.message);
  }
}
